var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"height":_vm.height}},[_c('div',{style:({ height: '100vh' }),attrs:{"id":"app"}},[(_vm.showOverlay && _vm.isAuthenticated)?_c('div',{ref:"loading",staticClass:"overlay d-flex align-center justify-center"}):_vm._e(),_c('v-container',{staticClass:"pa-0",style:(_vm.contentStyles),attrs:{"fluid":""}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }